export default function MultiTextInputWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const count = config.count ?? 4;
  const numbering = config.numbering ?? false;
  const startIndex = config.startIndex ?? 1;

  function setValue(index, v) {
    onChange({
      ...value,
      [index]: config.uppercase ? v.toUpperCase() : v
    });
  }

  function getInputStyle(i) {
    if (mode !== "review") return { border: "1px solid #aaa" };

    const part = feedback?.parts?.[i];
    if (!part) return { border: "1px solid #aaa" };

    return {
      border: `2px solid ${part.correct ? "#2e7d32" : "#c62828"}`
    };
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "14px",
        marginTop: "12px"
      }}
    >
      {Array.from({ length: count }).map((_, i) => {
        const label = i + startIndex;
        const part = feedback?.parts?.[i];

        return (
          <div
            key={i}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "4px"
            }}
          >
            {numbering === "above" && (
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#555"
                }}
              >
                {label}
              </div>
            )}

            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              {numbering === "inline" && (
                <span
                  style={{
                    width: "16px",
                    textAlign: "right",
                    fontSize: "14px",
                    color: "#555"
                  }}
                >
                  {label}.
                </span>
              )}

              <input
                type="text"
                value={value[i] || ""}
                maxLength={config.maxLength}
                disabled={mode !== "edit"}
                onChange={(e) => setValue(i, e.target.value)}
                style={{
                  width: "48px",
                  height: "36px",
                  textAlign: "center",
                  fontSize: "18px",
                  borderRadius: "4px",
                  ...getInputStyle(i)
                }}
              />

              {config.adornment && (
                <span style={{ fontSize: "26px", lineHeight: "1" }}>
                  {config.adornment}
                </span>
              )}
            </div>

            {/* Feedback (review mode only) */}
            {mode === "review" && part && !part.correct && (
              <div
                style={{
                  fontSize: "11px",
                  color: "#c62828",
                  marginTop: "2px",
                  textAlign: "center"
                }}
              >
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
